import { useTranslation } from 'react-i18next';
import { useRealtimeStore } from '@/shared/realtime/systemHub';

export function ConnectionLostBanner() {
  const { t } = useTranslation();
  const state = useRealtimeStore((s) => s.system);
  if (state !== 'reconnecting' && state !== 'disconnected') return null;
  return (
    <div className="bg-warning/15 text-warning px-3 py-1 text-center text-xs">
      {t('shell.connectionLost')}
    </div>
  );
}
